import React, { useState } from "react";
import { Download, QrCode } from "lucide-react";
import { API } from "@/lib/api";

export default function QRGeneratorAdmin() {
  const [tableNumber, setTableNumber] = useState(1);
  const [tableCount, setTableCount] = useState(10);

  const baseUrl = window.location.origin;
  const tables = Array.from({ length: parseInt(tableCount, 10) || 0 }, (_, i) => i + 1);
  const qrUrl = (n) => `${API}/qr/${n}?base_url=${encodeURIComponent(baseUrl)}`;
  const tableUrl = (n) => `${baseUrl}/order?table=${n}`;

  const downloadAll = () => {
    tables.forEach((n) => {
      const a = document.createElement("a");
      a.href = qrUrl(n);
      a.download = `tulsi-table-${n}.png`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
  };

  return (
    <div data-testid="qr-admin">
      <h1 className="font-serif-display text-4xl text-gold-gradient mb-2">QR Code Generator</h1>
      <p className="text-sm text-[#D1C7C9] mb-6">Generate scannable QR codes — one per table — for customers to order.</p>

      <div className="bg-[#1A1A1A] border border-[#333] rounded-xl p-6 mb-6 flex flex-col sm:flex-row gap-4 items-end">
        <label className="block flex-1">
          <span className="text-xs uppercase tracking-widest text-[#D1C7C9] block mb-1">Number of tables</span>
          <input
            type="number"
            min="1"
            max="100"
            value={tableCount}
            onChange={(e) => setTableCount(e.target.value)}
            className="w-full bg-[#0A0A0A] border border-[#333] rounded-md px-3 py-2 text-sm text-[#FDFBF7] outline-none focus:border-[#E69138]"
            data-testid="qr-table-count"
          />
        </label>
        <button onClick={downloadAll} className="btn-saffron" data-testid="download-all-qr">
          <Download size={14} /> Download all PNGs
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
        {tables.map((n) => (
          <div key={n} className="bg-white rounded-xl p-4 flex flex-col items-center" data-testid={`qr-card-${n}`}>
            <img src={qrUrl(n)} alt={`QR Table ${n}`} className="w-full aspect-square object-contain" />
            <p className="mt-2 font-serif-display text-xl text-[#1A0B0E]">Table #{n}</p>
            <p className="text-[10px] text-gray-600 truncate w-full text-center" title={tableUrl(n)}>{tableUrl(n)}</p>
            <a href={qrUrl(n)} download={`tulsi-table-${n}.png`} className="mt-2 text-xs uppercase tracking-widest text-[#E69138] hover:underline" data-testid={`qr-download-${n}`}>
              <Download size={11} className="inline" /> PNG
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
